import { render, staticRenderFns } from "./MyVoting.vue?vue&type=template&id=60891c0c&scoped=true"
import script from "./MyVoting.vue?vue&type=script&lang=js"
export * from "./MyVoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60891c0c",
  null
  
)

export default component.exports